import { ExcelExportParams } from "@ag-grid-community/core";
import { AgGridReact } from "@ag-grid-community/react";
import React from "react";
import { useTableBoxContext } from "shared/components/table/box/TableBoxContext";
import { dataTableParamsForExcelExport } from "shared/components/table/data/DataTableExport";
import {
  MaybernTableBoxActions,
  MaybernTableBoxActionsProps,
  TableExportButton,
} from "shared/components/table/maybern/MaybernTableBoxActions";

export interface DataTableBoxActionsProps extends MaybernTableBoxActionsProps {
  showExport?: boolean;
  getExportParams?: (agGrid: AgGridReact) => ExcelExportParams | undefined;
}

export const DataTableBoxActions: React.FC<
  React.PropsWithChildren<DataTableBoxActionsProps>
> = ({ showExport = true, getExportParams, children, ...props }) => (
  <MaybernTableBoxActions {...props}>
    {children}
    {showExport && <DataTableExportButton getExportParams={getExportParams} />}
  </MaybernTableBoxActions>
);

const DataTableExportButton: React.FC<{
  getExportParams?: (agGrid: AgGridReact) => ExcelExportParams | undefined;
}> = ({ getExportParams }) => {
  const { title } = useTableBoxContext();
  const defaultGetter = (agGrid: AgGridReact) =>
    dataTableParamsForExcelExport(agGrid, title);
  const paramsGetter = getExportParams || defaultGetter;
  return <TableExportButton getExportParams={paramsGetter} />;
};
